import { ActiveRecord, sources } from '@mysidewalk/active-record';
/**
 * @memberof system-metadata
 * @property {number} id
 * @property {string} sourceName
 * @property {string} sourceDetails
 * @property {string} timeLongName
 * @property {string} timeShortName
 * @property {date} publishedDate
 * @property {string} sourceTable
 * @property {string} universe
 * @property {string} description
 * @property {string} calculationMethodology
 * @property {boolean} supportsCustomGeographies
 * @property {number[]} featureClasses
 */
class ColumnDynamicAttribution extends ActiveRecord {
}
ColumnDynamicAttribution.$AR = {
    url: '',
    SourceClass: sources.ActiveRecordJSONAPISource,
};
export default ColumnDynamicAttribution;
